import React, { useEffect, useRef, useState } from 'react';
import { webLoadingFalse, webLoadingTrue, webNavigate } from '../../services/navigate.service';
import { validateDecimalNumer, validateMaxValue, validateNoSpecialChars } from '../../validation/ValidationInput';
import {
    DiscountType,
    PromoType,
    LINE_DISCOUNT_TYPE_OPTIONS,
    GLOBAL_HEADER_DISCOUNT_TYPE_OPTIONS,
} from '../../enums/promotion.enums';
import { showToast } from '../../services/toast.service';
import { showApiError } from '../../services/apiError';
import { inventoryFormLimits, limitProps, useFieldLimits, validateAgainstLimits } from '../../services/fieldLimits';
import FieldCounter from '../../components/FieldCounter';
import BackIcon from '../../images/BackIcon';
import {
    getSchedules,
} from '../../services/schedule.service';
import { useInfiniteScroll } from '../../hook/useInfiniteScroll';
import { getListProduct } from '../../services/items.services';
import SearchIcon from '../../images/SearchIcon';
import CloseIcon from '../../images/CloseIcon';
import WhiteCheckIcon from '../../images/WhiteCheckIcon';
import PlusGreenIcon from '../../images/PlusGreenIcon';
import ProductSelectionModal from '../../components/ProductSelectionModal';
import AttributeSelectionModal from '../../components/AttributeSelectionModal';
import { getListAttributes } from '../../services/attributes.service';
import { DropdownSearch } from '../../components/DropdownSearch';
import { createPromotion, getDetailsPromotion, updatePromotion } from '../../services/promotion.service';
import { useResponsive } from '../../hook/useResponsive';
import { useDialogFocus, useFormKeyboard } from '../../hook/useFormKeyboard';
interface PromotionFormValues {
    promoName: string;
    promoType?: number;
    value?: string;
    headerDiscountType?: number;
    promoDescription?: string;
    isGlobal: boolean;
    isStackable: boolean;
    isVisible: boolean;
    itemsRotate: boolean;
    scheduleId: string;
    productPromoDetail: ProductPromoDetail[];
}
interface ProductPromoDetail {
    itemType?: string;
    productId?: string;
    attributeId?: string;
    groupName?: string;
    productName?: string;
    attributeName?: string;
    sku?: string;
    uomName?: string;
    targetTrigger?: number,
    value?: number,
    discountType?: number,
    isAttributes?: boolean,
}

// Space on a div switch clicks it once, as on a native checkbox; Enter is left to the form.
const clickOnSpace = (e: React.KeyboardEvent<HTMLElement>) => {
    if (e.key !== ' ' || e.ctrlKey || e.metaKey || e.altKey) return;
    e.preventDefault();
    if (!e.repeat) e.currentTarget.click();
};

const CreatePromotions = () => {
    const [formValues, setFormValues] = useState<PromotionFormValues>({
        promoName: '',
        value: '0',
        headerDiscountType: DiscountType.value,
        promoType: undefined,
        scheduleId: '',
        promoDescription: '',
        isGlobal: false,
        isStackable: false,
        isVisible: false,
        itemsRotate: false,
        productPromoDetail: []
    });
    const { isMobile, getWidth } = useResponsive();
    const PAGE_SIZE = 50;
    const initalFilter = {
        searchValue: '',
        page: 1,
        searchValueProduct: '',
        initLoad: false
    };
    const initalAttributeFilter = {
        searchValue: '',
        page: 1,
        initLoad: false
    };
    const dropdownValueTypeRef = useRef<HTMLDivElement>(null);
    const [isValueTypeDropdownOpen, setIsValueTypeDropdownOpen] = useState<Record<string, boolean>>({});
    const hasLoadedPageRef = useRef(new Set<number>());
    const preLanguage = localStorage.getItem('language');
    const [listProducts, setListProducts] = useState<ProductPromoDetail[]>([]);
    const [listAttributes, setListAttributes] = useState<any>([]);
    const [listRawAttributes, setListRawAttributes] = useState<any>([]);
    const [listProductsSelect, setListProductsSelect] = useState<ProductPromoDetail[]>([]);
    const [listAttributesSelect, setListAttributesSelect] = useState<any[]>([]);
    const [filter, setFilter] = useState<any>(initalFilter);
    const [filterAttribute, setFilterAttribute] = useState<any>(initalAttributeFilter);
    const [language, setLanguage] = useState<any>(null);
    const limits = useFieldLimits(inventoryFormLimits('promotion'));
    const [showPopupCreate, setShowPopupCreate] = useState<boolean>(false);
    const [showPopupAttributeCreate, setShowPopupAttributeCreate] = useState<boolean>(false);
    const [errors, setErrors] = useState<any>({});
    const [searchValueType, setSearchValueType] = useState<any>([]);
    const [hasMore, setHasMore] = useState({
        product: true,
        attribute: false,
    });
    const [loading, setLoading] = useState({
        product: true,
        attribute: false,
    });
    const scrollRef = useRef<HTMLDivElement | null>(null);
    const searchInpuGlobaltRef = useRef<HTMLInputElement | null>(null);
    const [listSchedules, setListSchedules] = useState<any[]>([]);
    const path = window.location.pathname;
    const [searchType, setSearchType] = useState('');
    const [isTypeDropdownOpen, setIsTypeDropdownOpen] = useState(false);
    const dropdownTypeRef = useRef<HTMLDivElement>(null);
    const [searchSchedules, setSearchSchedules] = useState('');
    const [isSchedulesDropdownOpen, setIsSchedulesDropdownOpen] = useState(false);
    const dropdownSchedulesRef = useRef<HTMLDivElement>(null);
    const dropdownHeaderDiscountRef = useRef<HTMLDivElement>(null);
    const [searchHeaderDiscountType, setSearchHeaderDiscountType] = useState('Value');
    const [isHeaderDiscountDropdownOpen, setIsHeaderDiscountDropdownOpen] = useState(false);
    const [listHighlight, setListHighlight] = useState(-1);
    const listType = [
        {
            value: PromoType.Offer,
            name: 'Offer',
        },
        {
            value: PromoType.Discount,
            name: 'Discount',
        },
        {
            value: PromoType.Promo,
            name: 'Promo',
        },
    ];
    const listDiscountType = LINE_DISCOUNT_TYPE_OPTIONS;
    const listHeaderDiscountType = GLOBAL_HEADER_DISCOUNT_TYPE_OPTIONS;
    const id: string = path.split('/').pop() || '';
    const kb = useFormKeyboard({ autoFocus: id === 'new' && !isMobile });
    // The selection modals get scopes of their own, so Enter inside them never saves the promo.
    const productModalKb = useFormKeyboard();
    const attributeModalKb = useFormKeyboard();
    useDialogFocus(showPopupCreate, productModalKb.scopeRef, () => setShowPopupCreate(false));
    useDialogFocus(showPopupAttributeCreate, attributeModalKb.scopeRef, () => setShowPopupAttributeCreate(false));
    const handleChange = (field: any, value: any) => {
        setFormValues(prev => ({
            ...prev,
            [field]: value,
        }));
    };
    const handleKeyDown = (event: KeyboardEvent) => {
        if ((event.ctrlKey || event.metaKey) && event.key === 'f') {
            event.preventDefault();
            if (searchInpuGlobaltRef.current) {
                searchInpuGlobaltRef.current.focus();
            }
        }
    };
    useEffect(() => {
        window.addEventListener('keydown', handleKeyDown);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [showPopupCreate]);
    useEffect(() => {
        if (window.languageContext) {
            setLanguage(window.languageContext.language);
        }
    }, [window, window.languageContext]);

    const getListSchedules = async (val: any, valueId?: string) => {
        try {
            const response: any = await getSchedules(val);
            setListSchedules(response.data.data);
            if (valueId && id !== "new") {
                const value = response.data.data.find((val: any) => val.id === valueId);
                setSearchSchedules(value?.scheduleName ?? '')
            }
        } catch (error) {
            console.error('Error loading terms:', error);
        } finally {
        }
    };

    useEffect(() => {
        onLoadMore();
        if (id === "new") {
            getListSchedules({ page: 0, limit: 0, searchValue: '' })
            fetchAttributes('');
        }
        const handleNewToken = () => {
            onLoadMore();
            if (id === "new") {
                getListSchedules({ page: 0, limit: 0, searchValue: '' })
                fetchData(id);
                fetchAttributes('');
            }
        };
        document.addEventListener('newToken', handleNewToken);
        return () => {
            document.removeEventListener('newToken', handleNewToken);
        };
    }, [path]);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (dropdownTypeRef.current && !dropdownTypeRef.current.contains(event.target as Node)) {
                setIsTypeDropdownOpen(false);
            }
            if (dropdownSchedulesRef.current && !dropdownSchedulesRef.current.contains(event.target as Node)) {
                setIsSchedulesDropdownOpen(false);
            }
            if (dropdownHeaderDiscountRef.current && !dropdownHeaderDiscountRef.current.contains(event.target as Node)) {
                setIsHeaderDiscountDropdownOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const fetchData = async (id: any) => {
        webLoadingTrue();
        try {
            const response: any = await getDetailsPromotion(id);
            const data = response.data.data;
            const headerDt =
                data.isGlobal && data.promoType === PromoType.Discount
                    ? [DiscountType.value, DiscountType.percentage].includes(Number(data.discountType))
                        ? Number(data.discountType)
                        : DiscountType.value
                    : DiscountType.value;
            setSearchHeaderDiscountType(
                listHeaderDiscountType.find((v: any) => v.value === headerDt)?.name ?? 'Value',
            );
            setFormValues({
                promoName: data.promoName,
                value: data.isGlobal && data.promoType === PromoType.Discount ? String(data.value ?? '') : '0',
                headerDiscountType: headerDt,
                promoType: data.promoType,
                scheduleId: data.scheduleId,
                isGlobal: data.promoType === PromoType.Offer ? false : data.isGlobal,
                promoDescription: data.promoDescription,
                isStackable: data.isStackable,
                isVisible: data.isVisible,
                itemsRotate: !!data.itemsRotate,
                productPromoDetail: [
                    ...(response.data.data.promotionAttributes || []).map((val: any) => ({
                        itemType: "Attribute",
                        attributeId: val.attributeId,
                        attributeName: val.attribute?.attributeName || '',
                        displayName: val.attribute?.displayName || '',
                        type: val.attribute?.type || 1,
                        targetTrigger: Number(val.targetTrigger) || 1,
                        value: Number(val.value) || 0,
                        discountType: Number(val.discountType) || 1,
                        isAttributes: true,
                    })),
                    ...(response.data.data.promotionProducts || []).map((val: any) => {
                        return {
                            itemType: "Product",
                            productId: val.productId,
                            groupName: val.product?.productGroup?.groupName || '',
                            productName: val.product?.productName || '',
                            sku: val.product?.sku || '',
                            uomName: val.product?.productUOMs?.find((v: any) => v.isBase)?.uom?.uomName || '',
                            targetTrigger: Number(val.targetTrigger) || 1,
                            value: Number(val.value) || 0,
                            discountType: Number(val.discountType) || 1,
                            isAttributes: true,
                        };
                    })
                ]
            });
            const attributesMap = Object.fromEntries(
                response.data.data.promotionAttributes.map((item: any) => [
                    item.attributeId,
                    listDiscountType.find((v: any) => v.value == item.discountType)?.name || ''
                ])
            );

            const productsMap = Object.fromEntries(
                response.data.data.promotionProducts.map((item: any) => [
                    item.productId,
                    listDiscountType.find((v: any) => v.value == item.discountType)?.name || ''
                ])
            );
            setSearchValueType({ ...attributesMap, ...productsMap });
            setSearchType(listType.filter((v: any) => v.value === data.promoType)[0]?.name);
            setSearchSchedules(data.schedule?.scheduleName || '');
            if (id !== "new") {
                fetchAttributes('', response.data.data.promotionAttributes);
                getListSchedules({ page: 0, limit: 0, searchValue: '' }, response.data.data.scheduleId);
            }
            return response.data.data.promotionProducts
        } catch (error) {
            console.error('Error loading terms:', error);
        } finally {
            webLoadingFalse();
        }
    };

    const fetchAttributes = async (val: any, listAttributesResponse?: any[]) => {
        try {
            const response: any = await getListAttributes(localStorage.getItem('companyId') ?? '', 0, 0, val);
            if (id !== "new" && listAttributesResponse && listAttributesResponse.length > 0) {
                const updatedProducts = response.data.data.attributes.map((value: any, index: any) => {
                    return {
                        attributeId: value.id,
                        displayName: value.displayName,
                        attributeName: value.attributeName,
                        type: value.type,
                        targetTrigger: 1,
                        value: 0,
                        discountType: 1,
                        itemType: "Attribute",
                        isAttributes: listAttributesResponse.some((val) => val.attributeId === value.id)
                    }
                })
                setListAttributes(updatedProducts);
                setListRawAttributes(updatedProducts);
            } else {
                const dataArray = response.data.data.attributes.map((value: any, index: any) => {
                    return {
                        attributeId: value.id,
                        displayName: value.displayName,
                        attributeName: value.attributeName,
                        type: value.type,
                        targetTrigger: 1,
                        value: 0,
                        discountType: 1,
                        itemType: "Attribute",
                        isAttributes: false
                    }
                })
                setListAttributes(dataArray);
                setListRawAttributes(dataArray);
            }

        } catch (error) {
            console.error("Error loading terms:", error);
        } finally {

        }
    };

    const onLoadMore = async () => {
        if (hasLoadedPageRef.current.has(filter.page)) return;
        hasLoadedPageRef.current.add(filter.page);
        setLoading(prev => ({ ...prev, product: true }));
        await fetchAndAppendProductList(
            filter,
            id,
            formValues?.productPromoDetail || [],
            PAGE_SIZE,
            true
        );
    };

    const { setLoaderRef } = useInfiniteScroll({
        hasMore: hasMore.product,
        loading: loading.product,
        onLoadMore: onLoadMore,
        scrollRootRef: scrollRef,
    });
    const fetchAndAppendProductList = async (
        filter: any,
        id: string,
        listProductAttributes: any[],
        PAGE_SIZE: number,
        isAppend: boolean = true
    ) => {
        try {
            setLoading(prev => ({ ...prev, product: true }));
            let productSelect: any[] = listProductAttributes;
            if (filter.page === 1 && id !== 'new') {
                const tempData: any = await fetchData(id);
                const templateMap = new Map(
                    tempData.map((attr: { productId: any }) => [attr.productId, attr])
                );
                const filtered = listProductAttributes.filter(attr => templateMap.has(attr.productId));
                const existingProductIds = new Set(listProductAttributes.map(attr => attr.productId));
                const newOnes = tempData.filter(
                    (attr: { productId: string }) => !existingProductIds.has(attr.productId)
                );
                productSelect = [...filtered, ...newOnes];
            }
            const response: any = await getListProduct(
                filter.page,
                PAGE_SIZE,
                filter.searchValue,
                localStorage.getItem('companyId') || '',
            );
            const fetchedProducts = response.data.productWithCompany;
            const updatedProducts: any[] = fetchedProducts.map((value: any) => ({
                isAttributes: productSelect?.some(val => val.productId === value.id),
                productId: value.id,
                groupName: value.productGroup.groupName,
                productName: value.productName,
                itemType: "Product",
                sku: value.sku,
                uomName: value.productUOMs.find((v: any) => v.isBase)?.uom.uomName || '',
                targetTrigger: 1,
                value: 0,
                discountType: 1,
            }));

            if (isAppend) {
                setListProducts(prev => [...prev, ...updatedProducts]);
            } else {
                setListProducts(updatedProducts);
            }

            setFilter((prev: any) => ({
                ...prev,
                page: prev.page + 1,
                searchValue: prev.searchValue,
            }));

            if (fetchedProducts.length < PAGE_SIZE) {
                setHasMore(prev => ({ ...prev, product: false }));
            } else {
                setHasMore(prev => ({ ...prev, product: true }));
            }
        } catch (err) {
            console.error('Error fetching product list:', err);
            hasLoadedPageRef.current.delete(filter.page);
        } finally {
            setLoading(prev => ({ ...prev, product: false }));
        }
    };
    const handleTypeSelect = (value: any, name: any) => {
        setFormValues((prev: any) => ({
            ...prev,
            promoType: value,
            ...(value === PromoType.Offer
                ? { isGlobal: false, value: '0', headerDiscountType: DiscountType.value }
                : {}),
        }));
        setSearchType(name);
        setIsTypeDropdownOpen(false);
    };
    const handleSchedulesSelect = (value: any, name: any) => {
        setFormValues((prev: any) => ({
            ...prev,
            scheduleId: value,
        }));
        setSearchSchedules(name);
        setIsSchedulesDropdownOpen(false);
    };
    const handleHeaderDiscountSelect = (item: any) => {
        setFormValues((prev) => ({
            ...prev,
            headerDiscountType: item.value,
        }));
        setSearchHeaderDiscountType(item.name);
        setIsHeaderDiscountDropdownOpen(false);
    };
    // Click-only lists: arrows move, Enter/Tab pick the highlight, Escape closes.
    // Closed, Enter (Space too when read-only) opens the list instead of saving the form.
    const handleListKeyDown = <T,>(
        e: React.KeyboardEvent<HTMLInputElement>,
        isOpen: boolean,
        setOpen: (open: boolean) => void,
        items: T[],
        pick: (item: T) => void,
        openOnSpace = false,
    ) => {
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
            e.preventDefault();
            const from = isOpen ? listHighlight : -1;
            setOpen(true);
            setListHighlight(e.key === 'ArrowDown' ? Math.min(items.length - 1, from + 1) : Math.max(0, from - 1));
        } else if (!isOpen && (e.key === 'Enter' || (openOnSpace && e.key === ' ')) && !e.ctrlKey && !e.metaKey && !e.altKey) {
            e.preventDefault();
            if (e.repeat) return;
            setOpen(true);
            setListHighlight(-1);
        } else if (isOpen && e.key === 'Enter' && (e.ctrlKey || e.metaKey)) {
            // Not prevented: the chord still saves the form.
            setOpen(false);
        } else if (isOpen && ((e.key === 'Enter' && !e.ctrlKey && !e.metaKey) || e.key === 'Tab')) {
            if (e.key === 'Enter') e.preventDefault();
            if (e.repeat) return;
            const item = items[listHighlight];
            if (item) pick(item);
            else setOpen(false);
        } else if (isOpen && e.key === 'Escape') {
            e.preventDefault();
            e.stopPropagation();
            setOpen(false);
        }
    };
    // A line's closed Value type list opens on Enter; an open one keeps Enter to itself.
    const openValueTypeOnEnter = (e: React.KeyboardEvent<HTMLElement>, itemId: string) => {
        if (e.key !== 'Enter' || e.defaultPrevented || e.ctrlKey || e.metaKey || e.altKey || isValueTypeDropdownOpen[itemId]) return;
        e.preventDefault();
        if (!e.repeat) setIsValueTypeDropdownOpen((prev) => ({ ...prev, [itemId]: true }));
    };

    const toggleAction = () => {
        if (formValues.promoType === PromoType.Offer) {
            return;
        }
        const turningGlobalOn = !formValues.isGlobal;
        if (turningGlobalOn) {
            setSearchValueType({});
        }
        setFormValues((prev) => {
            const nextGlobal = !prev.isGlobal;
            return {
                ...prev,
                isGlobal: nextGlobal,
                ...(nextGlobal
                    ? {
                          productPromoDetail: [],
                          headerDiscountType: prev.headerDiscountType ?? DiscountType.value,
                      }
                    : { value: '0', headerDiscountType: DiscountType.value }),
            };
        });
    };

    const handleCheckboxChange = (option: string) => {
        setFormValues((prev: any) => ({
            ...prev,
            [option]: !prev[option]
        }));
    };
    const handleSelectProduct = (value: any) => {
        const updatedProducts = listProducts.map((product: any) => {
            if (product.productId === value.productId) {
                return { ...product, isAttributes: !product.isAttributes };
            }
            return product;
        });
        const toggledProduct = updatedProducts.find((p: any) => p.productId === value.productId);
        if (toggledProduct && !toggledProduct.isAttributes) {
            const updatedProductPromoDetail = formValues?.productPromoDetail.map((v: any) => {
                if (v.itemType === "Product" && v.productId === value.productId) {
                    return { ...v, isAttributes: false };
                }
                return v;
            });
            setFormValues((prev: any) => ({
                ...prev,
                productPromoDetail: updatedProductPromoDetail
            }));
        }
        const previouslySelected = listProductsSelect.filter(
            (selected: any) =>
                !listProducts.some((product: any) => product.productId === selected.productId)
        );
        const currentlySelected = updatedProducts.filter((product: any) => product.isAttributes);
        const merged = [...previouslySelected, ...currentlySelected];
        const uniqueMap = new Map();
        merged.forEach((item: any) => {
            uniqueMap.set(item.productId, item);
        });
        const result = Array.from(uniqueMap.values());
        setListProducts(updatedProducts);
        setListProductsSelect(result);
    };
    const handleSubmitSearchProduct = async (event: React.KeyboardEvent<HTMLInputElement>) => {
        // Ctrl/Cmd+Enter is left to the modal scope, which presses Save.
        if (event.key === 'Enter' && !event.ctrlKey && !event.metaKey) {
            event.preventDefault();
            hasLoadedPageRef.current.add(1);
            loadDataProduct({ searchValue: filter.searchValue, page: 1 });
            setFilter((prev: any) => ({
                ...prev,
                page: 1,
                searchValue: filter.searchValue,
            }));
            if (filter.searchValue === '') {
                setFilter((prev: any) => ({
                    ...prev,
                    page: 2,
                    searchValue: '',
                }));
            }
        }
    };
    const loadDataProduct = async (filter: any) => {
        let selectedIds = new Set();
        const merged = [...formValues?.productPromoDetail.filter((v) => v.itemType === "Product") || [], ...listProductsSelect];
        const uniqueMap = new Map();
        merged.forEach(item => {
            uniqueMap.set(item.productId, item);
        });
        const result = Array.from(uniqueMap.values());
        selectedIds = new Set(result?.map(p => p.productId));
        const response: any = await getListProduct(
            filter.page,
            PAGE_SIZE,
            filter.searchValue,
            localStorage.getItem('locationId') || '',
        );
        const fetchedProducts = response.data.productWithCompany;
        const updatedProducts: any[] = fetchedProducts.map((value: any) => ({
            isAttributes: selectedIds.has(value.id),
            productId: value.id,
            groupName: value.productGroup.groupName,
            productName: value.productName,
            sku: value.sku,
            uomName: value.productUOMs.find((v: any) => v.isBase)?.uom.uomName || '',
            targetTrigger: value.targetTrigger,
            value: value.value,
            discountType: value.discountType,
            itemType: "Product",
        }));
        if (filter.searchValue === "") {
            const allProducts = [...updatedProducts, ...listProductsSelect];
            const finalMap = new Map();
            allProducts.forEach(item => {
                finalMap.set(item.productId, item);
            });
            setListProducts(Array.from(finalMap.values()));
        } else {
            setListProducts(updatedProducts);
        }
    };
    const handleCancelAddProduct = () => {
        let selectedIds = new Set();
        selectedIds = new Set(formValues?.productPromoDetail?.map(p => p.productId));
        const updatedProducts: any[] = listProducts.map((value: any) => ({
            ...value,
            isAttributes: selectedIds.has(value.productId),
            productId: value.id,
            groupName: value.groupName,
            productName: value.productName,
            sku: value.sku,
            uomName: value.uomName || '',
            targetTrigger: value.targetTrigger,
            value: value.value,
            discountType: value.discountType,
        }));
        setListProducts(updatedProducts)
        setShowPopupCreate(false);
    }

    const handleCancelAddAttribute = () => {
        setShowPopupAttributeCreate(false);
    }

    const handleAddAttribute = () => {
        const merged = [...formValues?.productPromoDetail.filter((v) => v.itemType === "Attribute") || [], ...listAttributesSelect.filter(p => p.isAttributes)];
        const uniqueMap = new Map();
        merged.forEach(item => {
            uniqueMap.set(item.attributeId, item);
        });
        const result = Array.from(uniqueMap.values());
        const tempData = result
            .map((item: any) => {
                const existingDetail = formValues?.productPromoDetail.find(
                    detail => detail.attributeId === item.attributeId
                );
                if (existingDetail) {
                    existingDetail.isAttributes = true;
                    return existingDetail;
                }
                return {
                    isAttributes: item.isAttributes,
                    itemType: "Attribute",
                    attributeId: item.attributeId,
                    attributeName: item.attributeName,
                    displayName: item.displayName,
                    type: item.type,
                    targetTrigger: item.targetTrigger,
                    value: item.value,
                    discountType: item.discountType,
                };
            });
        const searchUOM = Object.fromEntries(
            tempData
                .filter((v) => v.itemType === "Attribute")
                .map((item: any, index: number) => [
                    item.attributeId,
                    listDiscountType.find((v: any) => v.value === item.discountType)?.name || ''
                ])
        );
        setSearchValueType((prev: any) => ({
            ...prev,
            ...searchUOM
        }));
        setFormValues((prev: any) => {
            if (!prev) return null;
            return { ...prev, productPromoDetail: [...prev.productPromoDetail.filter((v: any) => v.itemType !== "Attribute"), ...tempData] };
        });
        setShowPopupAttributeCreate(false);
    }

    const handleAddProduct = () => {
        const merged = [...formValues?.productPromoDetail.filter((v) => v.itemType === "Product" && v.isAttributes) || [], ...listProductsSelect.filter(p => p.isAttributes)];
        const uniqueMap = new Map();
        merged.forEach(item => {
            uniqueMap.set(item.productId, item);
        });
        const result = Array.from(uniqueMap.values());
        const tempData = result
            .map((item: any) => {
                const existingDetail = formValues?.productPromoDetail.find(
                    detail => detail.productId === item.productId
                );
                if (existingDetail) {
                    existingDetail.isAttributes = true;
                    return existingDetail;
                }
                return {
                    isAttributes: item.isAttributes,
                    productId: item.productId,
                    itemType: "Product",
                    groupName: item.groupName,
                    productName: item.productName,
                    sku: item.sku,
                    uomName: item.uomName,
                    targetTrigger: item.targetTrigger,
                    value: item.value,
                    discountType: item.discountType,
                };
            });
        const searchUOM = Object.fromEntries(
            tempData
                .filter((v) => v.itemType === "Product")
                .map((item: any, index: number) => [
                    item.productId,
                    listDiscountType.find((v: any) => v.value === item.discountType)?.name || ''
                ])
        );
        setSearchValueType((prev: any) => ({
            ...prev,
            ...searchUOM
        }));
        setFormValues((prev: any) => {
            if (!prev) return null;
            return { ...prev, productPromoDetail: [...prev.productPromoDetail.filter((v: any) => v.itemType !== "Product"), ...tempData] };
        });
        setShowPopupCreate(false);
    };

    const handleSubmitSearchAttribute = async (event: React.KeyboardEvent<HTMLInputElement>) => {
        // Ctrl/Cmd+Enter is left to the modal scope, which presses Save.
        if (event.key === 'Enter' && !event.ctrlKey && !event.metaKey) {
            event.preventDefault();
            if (filterAttribute.searchValue === '') {
                setListAttributes(listRawAttributes)
            } else {
                const filteredAttributes = listRawAttributes.filter((attr: any) =>
                    attr.attributeName.toLowerCase().includes(filterAttribute.searchValue.toLowerCase())
                );
                setListAttributes(filteredAttributes);
            }
        }
    }

    const handleSelectAttribute = (index: number) => {
        const tempAttributes = [...listAttributes];
        const selectedAttributes = tempAttributes[index];
        selectedAttributes.isAttributes = !selectedAttributes.isAttributes;
        const exists = listAttributesSelect.some(attr => attr.attributeId === selectedAttributes.id);
        const updatedAttributes = exists
            ? listAttributesSelect.filter(attr => attr.attributeId !== selectedAttributes.id)
            : [...listAttributesSelect, selectedAttributes];
        setListAttributes(tempAttributes);
        setListRawAttributes(tempAttributes);
        setListAttributesSelect(updatedAttributes);
    }

    const handleChangeDetailProduct = (index: number, event: any, type: 'value' | 'targetTrigger') => {
        const value = event.target.value;
        const tempArray = [...(formValues?.productPromoDetail || [])];
        tempArray[index] = { ...tempArray[index], [type]: value };
        setFormValues(prev => (prev ? { ...prev, productPromoDetail: tempArray } : prev));
    };

    // Target is a small whole-number trigger; step it instead of typing.
    const stepTarget = (index: number, delta: number) => {
        const tempArray = [...(formValues?.productPromoDetail || [])];
        const current = Number(tempArray[index]?.targetTrigger) || 0;
        tempArray[index] = { ...tempArray[index], targetTrigger: Math.max(1, current + delta) };
        setFormValues(prev => (prev ? { ...prev, productPromoDetail: tempArray } : prev));
    };

    // Drop a line without the picker-modal round trip; keep the pickers in sync.
    const handleRemoveLine = (index: number) => {
        const line = formValues?.productPromoDetail?.[index];
        if (!line) return;
        setFormValues(prev =>
            prev
                ? { ...prev, productPromoDetail: prev.productPromoDetail.filter((_, i) => i !== index) }
                : prev,
        );
        if (line.itemType === 'Product') {
            setListProducts(prev => prev.map((p: any) => (p.productId === line.productId ? { ...p, isAttributes: false } : p)));
            setListProductsSelect(prev => prev.filter((p: any) => p.productId !== line.productId));
        } else {
            setListAttributes((prev: any[]) => prev.map((a: any) => (a.attributeId === line.attributeId ? { ...a, isAttributes: false } : a)));
            setListRawAttributes((prev: any[]) => prev.map((a: any) => (a.attributeId === line.attributeId ? { ...a, isAttributes: false } : a)));
            setListAttributesSelect(prev => prev.filter((a: any) => a.attributeId !== line.attributeId));
        }
    };

    const handleValueTypeSelect = (value: any, itemId: string, itemType: any) => {
        setSearchValueType((prev: any) => ({
            ...prev,
            [itemId]: value.name,
        }));
        setIsValueTypeDropdownOpen((prev) => ({ ...prev, [itemId]: false }));
        setFormValues((prev: any) => {
            const newList = prev.productPromoDetail.map((item: any) => {
                const itemKey = item.itemType === "Product" ? item.productId : item.attributeId;
                if (itemKey !== itemId) return item;
                return {
                    ...item,
                    discountType: value.value,
                };
            });
            return {
                ...prev,
                productPromoDetail: newList,
            };
        });
    };


    const handleSubmit = async (e: React.SyntheticEvent) => {
        e.preventDefault();
        const isOffer = formValues.promoType === PromoType.Offer;
        const isDiscount = formValues.promoType === PromoType.Discount;
        const isDiscountGlobal = isDiscount && formValues.isGlobal;
        const isDiscountRestricted = isDiscount && !formValues.isGlobal;

        const err = (key: string) => language?.[key] ?? key;
        const productLines = formValues.productPromoDetail.filter((v) => v.itemType === 'Product');
        const attributeLines = formValues.productPromoDetail.filter((v) => v.itemType === 'Attribute');

        const newErrors: any = validateAgainstLimits(
            formValues as any,
            limits,
            language,
            isDiscountGlobal ? ['promoName', 'promoDescription', 'value'] : ['promoName', 'promoDescription'],
        );
        if (!formValues.promoType) {
            newErrors.promoType = err('Promo Type is required');
        }
        const nameTrim = (formValues.promoName ?? '').trim();
        if (!nameTrim) {
            newErrors.promoName = err('Promo Name is required');
        }
        if (!formValues.scheduleId) {
            newErrors.scheduleId = err('Schedule is required');
        }
        if (isDiscountGlobal) {
            const pv = String(formValues.value ?? '').trim();
            if (pv === '' || Number.isNaN(Number(pv))) {
                newErrors.value = err('Promo Value is required');
            }
            const hdt = Number(formValues.headerDiscountType ?? 0);
            if (![DiscountType.value, DiscountType.percentage].includes(hdt)) {
                newErrors.headerDiscountType = err('Discount type is required');
            }
        }

        if (isOffer) {
            if (productLines.length + attributeLines.length === 0) {
                newErrors.mappings = err('At least one product or attribute mapping is required');
            }
            for (const line of productLines) {
                const tt = Number(line.targetTrigger);
                if (!Number.isFinite(tt) || tt <= 0) {
                    newErrors.mappings = err('Target is required for each offer product line');
                    break;
                }
                if (!Number.isFinite(Number(line.value))) {
                    newErrors.mappings = err('Amount is required for each offer product line');
                    break;
                }
                const dt = Number(line.discountType);
                if (![DiscountType.value, DiscountType.percentage, DiscountType.price_override].includes(dt)) {
                    newErrors.mappings = err('Discount type is required for each offer product line');
                    break;
                }
            }
            for (const line of attributeLines) {
                const tt = Number(line.targetTrigger);
                if (!Number.isFinite(tt) || tt <= 0) {
                    newErrors.mappings = err('Target is required for each offer attribute line');
                    break;
                }
                if (!Number.isFinite(Number(line.value))) {
                    newErrors.mappings = err('Amount is required for each offer attribute line');
                    break;
                }
                const dt = Number(line.discountType);
                if (![DiscountType.value, DiscountType.percentage, DiscountType.price_override].includes(dt)) {
                    newErrors.mappings = err('Discount type is required for each offer attribute line');
                    break;
                }
            }
        }

        if (isDiscountRestricted) {
            if (productLines.length + attributeLines.length === 0) {
                newErrors.mappings = err('At least one product or attribute mapping is required');
            }
            for (const line of [...productLines, ...attributeLines]) {
                if (!Number.isFinite(Number(line.value))) {
                    newErrors.mappings = err('Amount is required for each line');
                    break;
                }
                const dt = Number(line.discountType);
                if (![DiscountType.value, DiscountType.percentage, DiscountType.price_override].includes(dt)) {
                    newErrors.mappings = err('Discount type is required for each line');
                    break;
                }
            }
        }

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }
        setErrors({});

        const promotionAttributePayload = isDiscountGlobal
            ? []
            : attributeLines.map((v) => ({
                  attributeId: v.attributeId,
                  targetTrigger: Number(v?.targetTrigger ?? 0),
                  value: Number(v?.value ?? 0),
                  discountType: Number(v?.discountType ?? 0),
              }));

        const promotionProductPayload = isDiscountGlobal
            ? []
            : productLines.map((v) => ({
                  productId: v.productId,
                  targetTrigger: Number(v?.targetTrigger ?? 0),
                  value: Number(v?.value ?? 0),
                  discountType: Number(v?.discountType ?? 0),
              }));

        const discountType = isDiscountGlobal
            ? Number(formValues.headerDiscountType)
            : DiscountType.value;
        const headerValue = isDiscountGlobal ? Number(formValues.value) : 0;

        const payload: any = {
            promoName: nameTrim,
            value: headerValue,
            promoDescription: formValues.promoDescription,
            promoType: formValues.promoType,
            isGlobal: isOffer ? false : formValues.isGlobal,
            scheduleId: formValues.scheduleId,
            isStackable: formValues.isStackable,
            isVisible: formValues.isVisible,
            itemsRotate: formValues.itemsRotate,
            discountType,
            promotionAttribute: promotionAttributePayload,
            promotionProduct: promotionProductPayload,
        };
        webLoadingTrue();
        if (id === 'new') {
            try {
                const response: any = await createPromotion(payload);
                webNavigate('/' + preLanguage + '/promotion');
                webLoadingFalse();
                showToast({
                    message: language?.['Promotion Created !'] ?? 'Promotion Created !',
                    type: 'success',
                    duration: 20000,
                });
            } catch (error: any) {
                webLoadingFalse();
                showApiError(error, { language, setFieldErrors: setErrors });
            }
        } else {
            try {
                const response: any = await updatePromotion(id, payload);
                webNavigate('/' + preLanguage + '/promotion');
                showToast({
                    message: language?.['Promotion Updated !'] ?? 'Promotion Updated !',
                    type: 'success',
                    duration: 20000,
                });
            } catch (error: any) {
                webLoadingFalse();
                showApiError(error, { language, setFieldErrors: setErrors });
            } finally {
                webLoadingFalse();
            }
        }
    };

    const showRestrictedMappingUi = !(
        formValues.promoType === PromoType.Discount && formValues.isGlobal
    );
    const isDiscountGlobalUi =
        formValues.promoType === PromoType.Discount && formValues.isGlobal;
    const promoTypeOptions = listType.filter((item: any) => item.value !== PromoType.Promo || formValues.promoType === PromoType.Promo);

    return (
        <div {...kb.scopeProps}>
            <div className="lbg-white h-full">
                <div className="flex items-center ">
                    <button
                        type="button"
                        aria-label={language?.['Back'] ?? 'Back'}
                        className="w-6 h-6 flex items-center justify-center cursor-pointer"
                        onClick={() => {
                            webNavigate('/' + preLanguage + '/promotion');
                        }}
                    >
                        <BackIcon />
                    </button>
                    <p
                        style={{ fontSize: '14px', fontWeight: '500', lineHeight: '28px', color: '#222525' }}
                        className="font-inter"
                    >
                        {language && language?.['Back'] ? language?.['Back'] : 'Back'}
                    </p>
                </div>
                {id === 'new' ? (
                    <p
                        style={{
                            margin: '20px 0px',
                            fontSize: '20px',
                            fontWeight: '500',
                            lineHeight: '28px',
                            color: '#222525',
                        }}
                        className="font-inter"
                    >
                        {language && language?.['Add promo'] ? language?.['Add promo'] : 'Add promo'}
                    </p>
                ) : (
                    <p
                        style={{
                            margin: '20px 0px',
                            fontSize: '20px',
                            fontWeight: '500',
                            lineHeight: '28px',
                            color: '#222525',
                        }}
                        className="font-inter"
                    >
                        {language && language?.['Edit promo'] ? language?.['Edit promo'] : 'Edit promo'}
                    </p>
                )}
                <div
                    className='scroll-container'
                    style={{
                        width: '100%',
                        height: 'calc(100% - 96px - 67px)',
                        overflowY: 'scroll',
                        paddingBottom: "16px"
                    }}
                >
                    <div className="h-full">
                        <div className="flex items-center" style={{ gap: '24px', flexWrap: 'wrap' }}>
                            <div className="space-y-2" style={{ width: isMobile ? '100%' : 'calc(33% - 12px)' }}>
                                <div className="flex items-center">
                                    <p
                                        className="text-[14px] font-inter leading-[20px] font-medium"
                                        style={{ color: '#4A5353' }}
                                    >
                                        {language && language?.['Promo Name']
                                            ? language?.['Promo Name']
                                            : 'Promo Name'}
                                    </p>
                                    <p className="text-[14px] font-inter leading-[20px]" style={{ color: '#BA0E13' }}>
                                        {language && language?.['*'] ? language?.['*'] : '*'}
                                    </p>
                                </div>
                                <div className="w-full">
                                    <input
                                        value={formValues?.promoName}
                                        name="promoName"
                                        {...limitProps(limits, 'promoName')}
                                        onChange={e => handleChange('promoName', e.target.value)}
                                        className={`text-[14px] font-inter placeholder:text-placeholder text-input border border-[#DBE4E4] px-2 py-3 rounded-xl  outline-none focus-none bg-transparent w-full`}
                                    />
                                    <FieldCounter value={formValues?.promoName} max={limits.promoName?.maxLength} />
                                </div>
                                {errors.promoName && <p className="error">{errors.promoName}</p>}
                            </div>
                            <div className="space-y-2" style={{ width: isMobile ? '100%' : 'calc(33% - 12px)' }}>
                                <div className="flex items-center">
                                    <p
                                        className="text-[14px] font-inter leading-[20px] font-medium"
                                        style={{ color: '#4A5353' }}
                                    >
                                        {language && language?.['Promo Type']
                                            ? language?.['Promo Type']
                                            : 'Promo Type'}
                                    </p>
                                    <p
                                        className="text-[14px] font-inter leading-[20px] font-medium"
                                        style={{ color: '#BA0E13' }}
                                    >
                                        {language && language?.['*'] ? language?.['*'] : '*'}
                                    </p>
                                </div>
                                <div className="relative" ref={dropdownTypeRef}>
                                    <input
                                        type="text"
                                        value={searchType}
                                        role="combobox"
                                        aria-expanded={isTypeDropdownOpen}
                                        aria-autocomplete="list"
                                        onChange={e => {
                                            setSearchType(e.target.value);
                                            setIsTypeDropdownOpen(true);
                                            setListHighlight(-1);
                                        }}
                                        onClick={() => {
                                            setIsTypeDropdownOpen(true);
                                            setListHighlight(-1);
                                        }}
                                        onKeyDown={e => {
                                            handleListKeyDown(e, isTypeDropdownOpen, setIsTypeDropdownOpen, promoTypeOptions, (item: any) => handleTypeSelect(item.value, item.name));
                                            validateNoSpecialChars(e);
                                        }}
                                        className={`text-[14px] font-inter placeholder:text-placeholder text-input border border-[#DBE4E4] px-2 py-3 rounded-xl  outline-none focus-none bg-transparent w-full`}
                                    />
                                    {errors.type && <p className="error">{errors.type}</p>}
                                    {isTypeDropdownOpen && (
                                        <div role="listbox" className="absolute z-10 w-full mt-1 bg-white border border-[#EBEBED] rounded-md shadow-lg max-h-60 overflow-auto">
                                            {promoTypeOptions.map((item: any, index: number) => (
                                                <div
                                                    key={item.value}
                                                    role="option"
                                                    aria-selected={index === listHighlight}
                                                    className="px-4 py-2 cursor-pointer hover:bg-[#E7F1F1] text-main"
                                                    style={index === listHighlight ? { backgroundColor: '#E7F1F1' } : undefined}
                                                    onMouseDown={e => e.preventDefault()}
                                                    onClick={() => handleTypeSelect(item.value, item.name)}
                                                >
                                                    {language?.[item.name] ?? item.name}
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                                {errors.promoType && <p className="error">{errors.promoType}</p>}
                            </div>
                            <div className="space-y-2" style={{ width: isMobile ? '100%' : 'calc(33% - 12px)' }}>
                                <div className="flex items-center">
                                    <p
                                        className="text-[14px] font-inter leading-[20px] font-medium"
                                        style={{ color: '#4A5353' }}
                                    >
                                        {language && language?.['Schedules']
                                            ? language?.['Schedules']
                                            : 'Schedules'}
                                    </p>
                                    <p className="text-[14px] font-inter leading-[20px]" style={{ color: '#BA0E13' }}>
                                        {language && language?.['*'] ? language?.['*'] : '*'}
                                    </p>
                                </div>
                                <div className="relative" ref={dropdownSchedulesRef}>
                                    <input
                                        type="text"
                                        value={searchSchedules}
                                        role="combobox"
                                        aria-expanded={isSchedulesDropdownOpen}
                                        aria-autocomplete="list"
                                        onChange={e => {
                                            setSearchSchedules(e.target.value);
                                            setIsSchedulesDropdownOpen(true);
                                            setListHighlight(-1);
                                        }}
                                        onClick={() => {
                                            setIsSchedulesDropdownOpen(true);
                                            setListHighlight(-1);
                                        }}
                                        onKeyDown={e => {
                                            handleListKeyDown(e, isSchedulesDropdownOpen, setIsSchedulesDropdownOpen, listSchedules, (item: any) => handleSchedulesSelect(item.id, item.scheduleName));
                                            validateNoSpecialChars(e);
                                        }}
                                        className={`text-[14px] font-inter placeholder:text-placeholder text-input border border-[#DBE4E4] px-2 py-3 rounded-xl  outline-none focus-none bg-transparent w-full`}
                                    />
                                    {isSchedulesDropdownOpen && (
                                        <div role="listbox" className="absolute z-10 w-full mt-1 bg-white border border-[#EBEBED] rounded-md shadow-lg max-h-60 overflow-auto">
                                            {listSchedules.map((item: any, index: number) => (
                                                <div
                                                    key={item.id}
                                                    ref={index === listHighlight ? el => el?.scrollIntoView({ block: 'nearest' }) : undefined}
                                                    role="option"
                                                    aria-selected={index === listHighlight}
                                                    className="px-4 py-2 cursor-pointer hover:bg-[#E7F1F1] text-main"
                                                    style={index === listHighlight ? { backgroundColor: '#E7F1F1' } : undefined}
                                                    onMouseDown={e => e.preventDefault()}
                                                    onClick={() => handleSchedulesSelect(item.id, item.scheduleName)}
                                                >
                                                    {item.scheduleName}
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                                {errors.scheduleId && <p className="error">{errors.scheduleId}</p>}
                            </div>
                        </div>
                        <div className="space-y-2" style={{ width: '100%', margin: "20px 0px" }}>
                            <div
                                className="flex items-center gap-x-3"
                                style={{
                                    opacity: formValues.promoType === PromoType.Offer ? 0.6 : 1,
                                    pointerEvents: formValues.promoType === PromoType.Offer ? 'none' : 'auto',
                                }}
                            >
                                <div
                                    role="switch"
                                    aria-checked={formValues?.isGlobal === true}
                                    aria-disabled={formValues.promoType === PromoType.Offer}
                                    aria-label={language?.['Global promo'] ?? 'Global promo'}
                                    tabIndex={0}
                                    onKeyDown={clickOnSpace}
                                    className={`switch ${formValues?.isGlobal === true ? "on" : "off"}`}
                                    onClick={() => {
                                        toggleAction();
                                    }}
                                >
                                    <div
                                        className={`shadow_toggle slider ${formValues?.isGlobal === true ? "move-right" : "move-left"
                                            }`}
                                    ></div>
                                </div>
                                <div className="flex items-center">
                                    <p className="text-[14px] font-inter leading-[20px]" style={{ color: '#222525', fontWeight: 500 }}>
                                        {language && language?.['Global promo'] ? language?.['Global promo'] : 'Global promo'}
                                    </p>
                                </div>
                            </div>
                        </div>
                        {isDiscountGlobalUi && (
                            <div className="space-y-2" style={{ width: '100%' }}>
                                <div className="flex items-center">
                                    <p
                                        className="text-[14px] font-inter leading-[20px] font-medium"
                                        style={{ color: '#4A5353' }}
                                    >
                                        {language && language?.['Discount type']
                                            ? language?.['Discount type']
                                            : 'Discount type'}
                                    </p>
                                    <p
                                        className="text-[14px] font-inter leading-[20px] font-medium"
                                        style={{ color: '#BA0E13' }}
                                    >
                                        {language && language?.['*'] ? language?.['*'] : '*'}
                                    </p>
                                </div>
                                <div className="relative" ref={dropdownHeaderDiscountRef}>
                                    <input
                                        type="text"
                                        readOnly
                                        role="combobox"
                                        aria-expanded={isHeaderDiscountDropdownOpen}
                                        value={searchHeaderDiscountType}
                                        onClick={() => {
                                            setIsHeaderDiscountDropdownOpen(true);
                                            setListHighlight(-1);
                                        }}
                                        onKeyDown={e => handleListKeyDown(e, isHeaderDiscountDropdownOpen, setIsHeaderDiscountDropdownOpen, listHeaderDiscountType, handleHeaderDiscountSelect, true)}
                                        className={`text-[14px] font-inter placeholder:text-placeholder text-input border border-[#DBE4E4] px-2 py-3 rounded-xl  outline-none focus-none bg-transparent w-full cursor-pointer`}
                                    />
                                    {isHeaderDiscountDropdownOpen && (
                                        <div role="listbox" className="absolute z-10 w-full mt-1 bg-white border border-[#EBEBED] rounded-md shadow-lg max-h-60 overflow-auto">
                                            {listHeaderDiscountType.map((item: any, index: number) => (
                                                <div
                                                    key={item.value}
                                                    role="option"
                                                    aria-selected={index === listHighlight}
                                                    className="px-4 py-2 cursor-pointer hover:bg-[#E7F1F1] text-main"
                                                    style={index === listHighlight ? { backgroundColor: '#E7F1F1' } : undefined}
                                                    onMouseDown={e => e.preventDefault()}
                                                    onClick={() => handleHeaderDiscountSelect(item)}
                                                >
                                                    {language?.[item.name] ?? item.name}
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                                {errors.headerDiscountType && (
                                    <p className="error">{errors.headerDiscountType}</p>
                                )}
                            </div>
                        )}
                        {isDiscountGlobalUi && (
                            <div className="space-y-2" style={{ width: '100%' }}>
                                <div className="flex items-center">
                                    <p
                                        className="text-[14px] font-inter leading-[20px] font-medium"
                                        style={{ color: '#4A5353' }}
                                    >
                                        {language && language?.['Promo value']
                                            ? language?.['Promo value']
                                            : 'Promo value'}
                                    </p>
                                    <p
                                        className="text-[14px] font-inter leading-[20px] font-medium"
                                        style={{ color: '#BA0E13' }}
                                    >
                                        {language && language?.['*'] ? language?.['*'] : '*'}
                                    </p>
                                </div>
                                <div className="relative">
                                    <input
                                        type="text"
                                        value={formValues?.value}
                                        onKeyDown={validateDecimalNumer}
                                        name="value"
                                        onChange={e => handleChange('value', e.target.value)}
                                        className={`text-[14px] font-inter placeholder:text-placeholder text-input border border-[#DBE4E4] px-2 py-3 rounded-xl  outline-none focus-none bg-transparent w-full`}
                                    />
                                </div>
                                {errors.value && <p className="error">{errors.value}</p>}
                            </div>
                        )}
                        <div className="space-y-2" style={{ width: '100%', marginTop: '20px' }}>
                            <div className="flex items-center">
                                <p className="text-[14px] font-inter leading-[20px]" style={{ color: '#4A5353' }}>
                                    {language && language?.['Description'] ? language?.['Description'] : 'Description'}
                                </p>
                            </div>
                            <div className="w-full">
                                <textarea
                                    value={formValues?.promoDescription}
                                    onKeyDown={validateNoSpecialChars}
                                    name="promoDescription"
                                    {...limitProps(limits, 'promoDescription')}
                                    onChange={e => handleChange('promoDescription', e.target.value)}
                                    style={{ maxHeight: "114px" }}
                                    className={`text-[14px] font-inter placeholder:text-placeholder text-input border border-[#DBE4E4] px-2 py-3 rounded-xl  outline-none focus-none bg-transparent w-full`}
                                />
                                <FieldCounter value={formValues?.promoDescription} max={limits.promoDescription?.maxLength} />
                            </div>
                            {errors.promoDescription && <p className="error">{errors.promoDescription}</p>}
                        </div>
                        <div style={{ margin: '24px 0px' }}>
                            <label
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '8px',
                                    cursor: 'pointer'
                                }}
                            >
                                <input
                                    type="checkbox"
                                    checked={formValues?.isStackable}
                                    onChange={() => handleCheckboxChange('isStackable')}
                                    style={{
                                        width: '20px',
                                        height: '20px',
                                        borderRadius: "6px",
                                        cursor: 'pointer',
                                        accentColor: '#0F7679',
                                        border: '1px solid #C9D7D8'
                                    }}
                                />
                                <span style={{ fontSize: '14px', color: '#222525', fontWeight: '500', fontFamily: 'Inter' }}>
                                    {language && language?.['Applicable with other discounts'] ? language?.['Applicable with other discounts'] : 'Applicable with other discounts'}
                                </span>
                            </label>
                            <label
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '8px',
                                    cursor: 'pointer',
                                    marginTop: "12px"
                                }}
                            >
                                <input
                                    type="checkbox"
                                    checked={formValues?.isVisible}
                                    onChange={() => handleCheckboxChange('isVisible')}
                                    style={{
                                        width: '20px',
                                        height: '20px',
                                        borderRadius: "6px",
                                        cursor: 'pointer',
                                        accentColor: '#0F7679',
                                        border: '1px solid #C9D7D8'
                                    }}
                                />
                                <span style={{ fontSize: '14px', color: '#222525', fontWeight: '500', fontFamily: 'Inter' }}>
                                    {language && language?.['Visible to devices'] ? language?.['Visible to devices'] : 'Visible to devices'}
                                </span>
                            </label>
                            <label
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '8px',
                                    cursor: 'pointer',
                                    marginTop: "12px"
                                }}
                            >
                                <input
                                    type="checkbox"
                                    checked={formValues?.itemsRotate}
                                    onChange={() => handleCheckboxChange('itemsRotate')}
                                    style={{
                                        width: '20px',
                                        height: '20px',
                                        borderRadius: "6px",
                                        cursor: 'pointer',
                                        accentColor: '#0F7679',
                                        border: '1px solid #C9D7D8'
                                    }}
                                />
                                <span style={{ fontSize: '14px', color: '#222525', fontWeight: '500', fontFamily: 'Inter' }}>
                                    {language && language?.['Items change daily'] ? language?.['Items change daily'] : 'Items change daily'}
                                </span>
                            </label>
                        </div>
                        {errors.mappings && (
                            <p className="error" style={{ marginTop: 8 }}>
                                {errors.mappings}
                            </p>
                        )}
                        {
                            showRestrictedMappingUi &&
                            formValues?.productPromoDetail &&
                            formValues?.productPromoDetail.length > 0 &&
                            <div
                                style={{
                                    borderTopLeftRadius: '16px',
                                    borderTopRightRadius: '16px',
                                    backgroundColor: 'white',
                                    width: '100%',
                                    // Phones: auto height, the page scrolls. The old fixed
                                    // calc collapsed to ~0 on small viewports.
                                    height: isMobile ? 'auto' : 'calc(100% - 476px)',
                                    minHeight: isMobile ? undefined : '240px',
                                    marginBottom: '24px',
                                }}
                            >
                                {
                                    !isMobile &&
                                    <div
                                        className="w-full flex items-center h-10"
                                        style={{
                                            borderTopLeftRadius: '12px',
                                            borderTopRightRadius: '12px',
                                            padding: '0px 16px',
                                            backgroundColor: '#EBF0F0',
                                            borderLeft: '1px solid #DBE4E4',
                                            borderRight: '1px solid #DBE4E4',
                                            borderTop: '1px solid #DBE4E4',
                                        }}
                                    >
                                        {['Item Type', 'Value Type', 'Name', 'Amount', 'Target', ''].map((header, idx) => (
                                            <div
                                                key={header || 'actions'}
                                                className="text-[14px] font-medium leading-[18px] font-inter flex items-center h-full"
                                                style={{
                                                    color: '#6A7878',
                                                    width: header === '' ? '48px' : 'calc((100% - 48px) / 5)',
                                                    justifyContent: 'start',
                                                }}
                                            >
                                                {header ? (language?.[header] ?? header) : header}
                                            </div>
                                        ))}
                                    </div>
                                }
                                <div
                                    className="scroll-container rounded-b-md w-full"
                                    style={{
                                        height: isMobile ? 'auto' : 'calc(100% - 40px)',
                                        overflowY: 'auto',
                                        backgroundColor: '#FFFFFF',
                                    }}
                                    ref={scrollRef}
                                >
                                    {formValues?.productPromoDetail.map((value, idx) => {
                                        const itemId = (value.itemType === "Product" ? value.productId : value.attributeId) || `fallback-${idx}`;
                                        const baseStyle = isMobile ?
                                            {
                                                border: "1px solid #DBE4E4",
                                                borderRadius: "12px",
                                                padding: '16px',
                                                marginBottom: idx === formValues?.productPromoDetail.length - 1 ? '' : '12px'
                                            }
                                            :
                                            {
                                                borderBottom: '1px solid #DBE4E4',
                                                borderLeft: '1px solid #DBE4E4',
                                                borderRight: '1px solid #DBE4E4',
                                                borderBottomLeftRadius: idx === formValues?.productPromoDetail.length - 1 ? '12px' : '',
                                                borderBottomRightRadius: idx === formValues?.productPromoDetail.length - 1 ? '12px' : '',
                                                display: "flex",
                                                height: '40px',
                                                padding: '0px 16px',

                                            }
                                        return <div
                                            key={idx}
                                            className="items-center"
                                            style={baseStyle}
                                        >
                                            {
                                                isMobile ?
                                                    <>
                                                        <div
                                                            style={{ width: '100%', color: '#4A5353', display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between' }}
                                                            className="text-[14px] font-inter"
                                                        >
                                                            <div>
                                                                <p style={{ color: '#6A7878', marginBottom: '4px' }}>
                                                                    {language && language?.['Item Type']
                                                                        ? language?.['Item Type']
                                                                        : 'Item Type'}
                                                                </p>
                                                                <p style={{ color: '#222525' }}>{value.itemType ? (language?.[value.itemType] ?? value.itemType) : '-'}</p>
                                                            </div>
                                                            <button
                                                                type="button"
                                                                onClick={() => handleRemoveLine(idx)}
                                                                className="cursor-pointer font-inter"
                                                                style={{ color: '#BA0E13', fontSize: '13px', fontWeight: 500 }}
                                                            >
                                                                {language && language?.['Remove'] ? language?.['Remove'] : 'Remove'}
                                                            </button>
                                                        </div>
                                                        <div
                                                            style={{ width: '100%', color: '#4A5353', margin: '12px 0px' }}
                                                            className="text-[14px] font-inter"
                                                            onKeyDown={e => openValueTypeOnEnter(e, itemId)}
                                                        >
                                                            <p style={{ color: '#6A7878', marginBottom: '4px' }}>
                                                                {language && language?.['Value Type']
                                                                    ? language?.['Value Type']
                                                                    : 'Value Type'}
                                                            </p>
                                                            <DropdownSearch<{ value: number; name: string }>
                                                                refKey={`ValueTypeBase-${itemId}`}
                                                                refs={{
                                                                    [`ValueTypeBase-${itemId}`]: dropdownValueTypeRef,
                                                                }}
                                                                openStates={{
                                                                    [`ValueTypeBase-${itemId}`]: isValueTypeDropdownOpen[itemId] || false,
                                                                }}
                                                                open={() => {
                                                                    setIsValueTypeDropdownOpen((prev) => ({
                                                                        ...prev,
                                                                        [itemId]: true,
                                                                    }));
                                                                }}
                                                                close={() =>
                                                                    setIsValueTypeDropdownOpen((prev) => ({
                                                                        ...prev,
                                                                        [itemId]: false,
                                                                    }))
                                                                }
                                                                data={listDiscountType}
                                                                labelExtractor={(item) => language?.[item.name] ?? item.name}
                                                                value={searchValueType[itemId] || ""}
                                                                setValue={(val) =>
                                                                    setSearchValueType((prev: any) => ({
                                                                        ...prev,
                                                                        [itemId]: val,
                                                                    }))
                                                                }
                                                                onSelect={(selectedValue) =>
                                                                    handleValueTypeSelect(selectedValue, itemId, value?.itemType)
                                                                }
                                                                borderNone={false}
                                                                inItem={true}
                                                            />
                                                        </div>
                                                        <div className="flex items-center" style={{ gap: "24px" }}>
                                                            <div
                                                                style={{ width: 'calc(50% - 12px)' }}
                                                                className="text-[14px] font-inter"
                                                            >
                                                                <p style={{ color: '#6A7878', marginBottom: '4px' }}>
                                                                    {language && language?.['Name']
                                                                        ? language?.['Name']
                                                                        : 'Name'}
                                                                </p>
                                                                <p style={{ color: '#222525' }}>{value?.productName ? value?.productName : value?.attributeName}</p>
                                                            </div>
                                                            <div
                                                                style={{ width: 'calc(50% - 12px)' }}
                                                                className="text-[14px] font-inter"
                                                            >
                                                                <p style={{ color: '#6A7878', marginBottom: '4px' }}>
                                                                    {language && language?.['Amount']
                                                                        ? language?.['Amount']
                                                                        : 'Amount'}
                                                                </p>
                                                                <div className="flex items-center" style={{ border: '1px solid #DBE4E4', borderRadius: '10px', height: '44px', padding: '0 12px', backgroundColor: '#FFFFFF' }}>
                                                                    <input
                                                                        type="text"
                                                                        inputMode="decimal"
                                                                        name="value"
                                                                        value={value?.value ?? ''}
                                                                        placeholder="0.00"
                                                                        onKeyDown={(e) => {
                                                                            if (value.discountType === DiscountType.percentage) {
                                                                                validateMaxValue(e, 100);
                                                                            } else {
                                                                                validateDecimalNumer(e);
                                                                            }
                                                                        }}
                                                                        style={{ color: '#222525', fontSize: '16px', fontFamily: 'ui-monospace, Menlo, monospace', fontVariantNumeric: 'tabular-nums', fontWeight: 600 }}
                                                                        onChange={e => {
                                                                            handleChangeDetailProduct(idx, e, 'value');
                                                                        }}
                                                                        className="font-inter placeholder:text-placeholder outline-none focus-none bg-transparent w-full"
                                                                    />
                                                                </div>
                                                                {/* {value.value} */}
                                                            </div>
                                                        </div>
                                                        <div
                                                            style={{ width: '100%', color: '#4A5353' }}
                                                            className="text-[14px] font-inter"
                                                        >
                                                            <p style={{ color: '#6A7878', marginBottom: '4px' }}>
                                                                {language && language?.['Target']
                                                                    ? language?.['Target']
                                                                    : 'Target'}
                                                            </p>
                                                            <div className="flex items-center" style={{ border: '1px solid #DBE4E4', borderRadius: '10px', overflow: 'hidden', width: 'fit-content' }}>
                                                                <div
                                                                    onClick={() => stepTarget(idx, -1)}
                                                                    className="flex items-center justify-center cursor-pointer"
                                                                    style={{ width: '40px', height: '40px', color: '#0F7679', fontSize: '18px', backgroundColor: '#F8FAFA' }}
                                                                >
                                                                    −
                                                                </div>
                                                                <input
                                                                    type="text"
                                                                    inputMode="numeric"
                                                                    name="targetTrigger"
                                                                    value={value?.targetTrigger ?? ''}
                                                                    placeholder="1"
                                                                    onKeyDown={validateDecimalNumer}
                                                                    onBlur={() => stepTarget(idx, 0)}
                                                                    style={{ color: '#222525', width: '56px', textAlign: 'center', fontSize: '16px' }}
                                                                    onChange={e => {
                                                                        handleChangeDetailProduct(idx, e, 'targetTrigger');
                                                                    }}
                                                                    className="text-[14px] font-inter placeholder:text-placeholder outline-none focus-none bg-transparent"
                                                                />
                                                                <div
                                                                    onClick={() => stepTarget(idx, 1)}
                                                                    className="flex items-center justify-center cursor-pointer"
                                                                    style={{ width: '40px', height: '40px', color: '#0F7679', fontSize: '18px', backgroundColor: '#F8FAFA' }}
                                                                >
                                                                    +
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </>
                                                    :
                                                    <>
                                                        <div
                                                            style={{ width: 'calc((100% - 48px) / 5)', color: '#4A5353' }}
                                                            className="text-[14px] font-inter"
                                                        >
                                                            {value.itemType ? (language?.[value.itemType] ?? value.itemType) : '-'}
                                                        </div>
                                                        <div
                                                            style={{ width: 'calc((100% - 48px) / 5)', color: '#4A5353' }}
                                                            className="text-[14px] font-inter"
                                                            onKeyDown={e => openValueTypeOnEnter(e, itemId)}
                                                        >
                                                            <DropdownSearch<{ value: number; name: string }>
                                                                refKey={`ValueTypeBase-${itemId}`}
                                                                refs={{
                                                                    [`ValueTypeBase-${itemId}`]: dropdownValueTypeRef,
                                                                }}
                                                                openStates={{
                                                                    [`ValueTypeBase-${itemId}`]: isValueTypeDropdownOpen[itemId] || false,
                                                                }}
                                                                open={() => {
                                                                    setIsValueTypeDropdownOpen((prev) => ({
                                                                        ...prev,
                                                                        [itemId]: true,
                                                                    }));
                                                                }}
                                                                close={() =>
                                                                    setIsValueTypeDropdownOpen((prev) => ({
                                                                        ...prev,
                                                                        [itemId]: false,
                                                                    }))
                                                                }
                                                                data={listDiscountType}
                                                                labelExtractor={(item) => language?.[item.name] ?? item.name}
                                                                value={searchValueType[itemId] || ""}
                                                                setValue={(val) =>
                                                                    setSearchValueType((prev: any) => ({
                                                                        ...prev,
                                                                        [itemId]: val,
                                                                    }))
                                                                }
                                                                onSelect={(selectedValue) =>
                                                                    handleValueTypeSelect(selectedValue, itemId, value?.itemType)
                                                                }
                                                                borderNone={true}
                                                                inItem={true}
                                                            />
                                                        </div>
                                                        <div
                                                            style={{ width: 'calc((100% - 48px) / 5)', color: '#4A5353' }}
                                                            className="text-[14px] font-inter"
                                                        >
                                                            {value?.productName ? value?.productName : value?.attributeName}
                                                        </div>
                                                        <div
                                                            style={{ width: 'calc((100% - 48px) / 5)', color: '#4A5353' }}
                                                            className="text-[14px] font-inter"
                                                        >
                                                            <input
                                                                type="text"
                                                                inputMode="decimal"
                                                                name="value"
                                                                value={value?.value ?? ''}
                                                                placeholder="0"
                                                                onKeyDown={(e) => {
                                                                    if (value.discountType === DiscountType.percentage) {
                                                                        validateMaxValue(e, 100);
                                                                    } else {
                                                                        validateDecimalNumer(e);
                                                                    }
                                                                }}
                                                                style={{ padding: '12px 12px 12px 0' }}
                                                                onChange={e => {
                                                                    handleChangeDetailProduct(idx, e, 'value');
                                                                }}
                                                                className="text-[14px] font-inter placeholder:text-placeholder text-placeholder outline-none focus-none bg-transparent w-full"
                                                            />
                                                            {/* {value.value} */}
                                                        </div>
                                                        <div
                                                            style={{ width: 'calc((100% - 48px) / 5)', color: '#4A5353' }}
                                                            className="text-[14px] font-inter"
                                                        >
                                                            <div className="flex items-center" style={{ border: '1px solid #DBE4E4', borderRadius: '8px', overflow: 'hidden', width: 'fit-content' }}>
                                                                <div
                                                                    onClick={() => stepTarget(idx, -1)}
                                                                    className="flex items-center justify-center cursor-pointer"
                                                                    style={{ width: '28px', height: '28px', color: '#0F7679', fontSize: '15px', backgroundColor: '#F8FAFA' }}
                                                                >
                                                                    −
                                                                </div>
                                                                <input
                                                                    type="text"
                                                                    inputMode="numeric"
                                                                    name="targetTrigger"
                                                                    value={value?.targetTrigger ?? ''}
                                                                    placeholder="1"
                                                                    onKeyDown={validateDecimalNumer}
                                                                    onBlur={() => stepTarget(idx, 0)}
                                                                    style={{ width: '44px', textAlign: 'center' }}
                                                                    onChange={e => {
                                                                        handleChangeDetailProduct(idx, e, 'targetTrigger');
                                                                    }}
                                                                    className="text-[14px] font-inter placeholder:text-placeholder outline-none focus-none bg-transparent"
                                                                />
                                                                <div
                                                                    onClick={() => stepTarget(idx, 1)}
                                                                    className="flex items-center justify-center cursor-pointer"
                                                                    style={{ width: '28px', height: '28px', color: '#0F7679', fontSize: '15px', backgroundColor: '#F8FAFA' }}
                                                                >
                                                                    +
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div style={{ width: '48px' }} className="flex items-center justify-center">
                                                            <button
                                                                type="button"
                                                                onClick={() => handleRemoveLine(idx)}
                                                                className="cursor-pointer flex items-center justify-center"
                                                                title={language && language?.['Remove'] ? language?.['Remove'] : 'Remove'}
                                                                aria-label={`${language && language?.['Remove'] ? language?.['Remove'] : 'Remove'} ${value?.productName ? value?.productName : value?.attributeName ?? ''}`.trim()}
                                                                style={{ width: '28px', height: '28px', borderRadius: '8px', color: '#BA0E13', fontSize: '16px' }}
                                                            >
                                                                ✕
                                                            </button>
                                                        </div>
                                                    </>
                                            }
                                        </div>
                                    })}
                                </div>
                            </div>
                        }
                        {
                            showRestrictedMappingUi &&
                            <div className="w-full flex items-center" style={{ gap: '8px' }}>
                                <button
                                    type="button"
                                    onClick={() => {
                                        setShowPopupAttributeCreate(true);
                                    }}
                                    className="cursor-pointer text-[14px] leading-[22px] font-inter flex items-center justify-center font-medium"
                                    style={{
                                        borderRadius: '30px',
                                        border: '1px solid #C9D7D8',
                                        padding: "6px 12px 6px 6px",
                                        height: '40px',
                                        color: '#0F7679',
                                    }}
                                >
                                    <div className="flex items-center justify-center" style={{ width: "40px", height: "40px" }}>
                                        <PlusGreenIcon />
                                    </div>
                                    {language && language?.['Attributes'] ? language?.['Attributes'] : 'Attributes'}
                                </button>
                                <button
                                    type="button"
                                    onClick={() => {
                                        setShowPopupCreate(true);
                                    }}
                                    className="cursor-pointer text-[14px] leading-[22px] font-inter flex items-center justify-center font-medium"
                                    style={{
                                        borderRadius: '30px',
                                        border: '1px solid #C9D7D8',
                                        padding: "6px 12px 6px 6px",
                                        height: '40px',
                                        color: '#0F7679',
                                    }}
                                >
                                    <div className="flex items-center justify-center" style={{ width: "40px", height: "40px" }}>
                                        <PlusGreenIcon />
                                    </div>
                                    {language && language?.['Products'] ? language?.['Products'] : 'Products'}
                                </button>
                            </div>
                        }
                    </div>
                </div>
                <div
                    className="w-full flex items-center justify-end shadow_button relative"
                    style={{ gap: "12px", paddingTop: "24px", }}
                >
                    <div className="absolute" style={{ left: "-24px", top: 0, height: "1px", backgroundColor: "#DBE4E4", width: isMobile ? 'calc(100vw + 32px)' : "calc(-256px + 48px + 100vw)" }}></div>
                    <button
                        type="button"
                        onClick={() => {
                            webNavigate('/' + preLanguage + '/promotion');
                        }}
                        style={{
                            padding: '10px 24px',
                            borderRadius: '30px',
                            color: '#222525',
                            fontSize: '14px',
                            fontWeight: '500',
                            border: '1px solid #C9D7D8',
                        }}
                        className="font-inter cursor-pointer"
                    >
                        {language && language?.['Cancel'] ? language?.['Cancel'] : 'Cancel'}
                    </button>
                    <button
                        type="button"
                        {...kb.primaryProps(handleSubmit)}
                        style={{
                            padding: '10px 24px',
                            borderRadius: '30px',
                            color: '#FFFFFF',
                            fontSize: '14px',
                            fontWeight: '500',
                            backgroundColor: '#0F7679',
                        }}
                        className="font-inter cursor-pointer"
                    >
                        {language && language?.['Save'] ? language?.['Save'] : 'Save'}
                    </button>
                </div>
            </div>
            {/* visibility keeps the always-mounted modals out of the tab order while closed. */}
            <div {...productModalKb.scopeProps} style={{ ...productModalKb.scopeProps.style, visibility: showPopupCreate ? 'visible' : 'hidden' }}>
            <ProductSelectionModal
                showPopup={showPopupCreate}
                onClose={() => setShowPopupCreate(false)}
                products={listProducts}
                filter={filter}
                onFilterChange={setFilter}
                onSearchSubmit={handleSubmitSearchProduct}
                onSelectProduct={handleSelectProduct}
                onCancel={handleCancelAddProduct}
                onSave={handleAddProduct}
                saveButtonProps={productModalKb.primaryProps(handleAddProduct)}
                loading={loading.product}
                language={language}
                scrollRef={scrollRef}
                loaderRef={setLoaderRef}
                SearchIcon={SearchIcon}
                CloseIcon={CloseIcon}
                WhiteCheckIcon={WhiteCheckIcon}
            />
            </div>
            <div {...attributeModalKb.scopeProps} style={{ ...attributeModalKb.scopeProps.style, visibility: showPopupAttributeCreate ? 'visible' : 'hidden' }}>
            <AttributeSelectionModal
                showPopup={showPopupAttributeCreate}
                onClose={() => setShowPopupAttributeCreate(false)}
                products={listAttributes}
                filter={filterAttribute}
                onFilterChange={setFilterAttribute}
                onSearchSubmit={handleSubmitSearchAttribute}
                onSelectProduct={handleSelectAttribute}
                onCancel={handleCancelAddAttribute}
                onSave={handleAddAttribute}
                saveButtonProps={attributeModalKb.primaryProps(handleAddAttribute)}
                loading={loading.attribute}
                language={language}
                SearchIcon={SearchIcon}
                CloseIcon={CloseIcon}
                WhiteCheckIcon={WhiteCheckIcon}
            />
            </div>
        </div>
    );
};
export default CreatePromotions;
